// extracted by mini-css-extract-plugin
export default {"lang":"Lang_lang__BmIR6","outLang":"Lang_outLang__EtlCT"};